module.exports = __webpack_public_path__ + "static/lahmacun-guel-a1cfb09fdafb4904db63fb800004e139.png";